module.exports = __webpack_public_path__ + "img/20211013_2.02e5bd08.jpg";